import  { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(Tooltip, Legend, ArcElement);

const OptimalStockChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/inventoryJson`);
       

        if (response.data && response.data.data) {
          const rawData = response.data.data.Data;
          

          if (Array.isArray(rawData)) {
            const statusCount = {
              "BELOW OPTIMAL": 0,
              "STOCK OK": 0,
              "REORDER NOW": 0,
            };

            rawData.forEach(item => {
              const status = item["Status"];
              if (status === "BELOW OPTIMAL" || status === "STOCK OK" || status === "REORDER NOW") {
                statusCount[status] += 1;
              }
            });

            const dataset = {
              label: "Stock Status",
              data: [statusCount["BELOW OPTIMAL"], statusCount["STOCK OK"], statusCount["REORDER NOW"]],
              backgroundColor: ["rgba(255, 99, 132, 0.6)", "rgba(54, 162, 235, 0.6)", "rgba(75, 192, 192, 0.6)"],
              borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)", "rgba(75, 192, 192, 1)"],
              borderWidth: 1,
            };

            setChartData({
              labels: ["Below Optimal", "Stock OK", "Reorder Now"],
              datasets: [dataset],
            });
          } else {
            throw new Error("Data is not in expected array format.");
          }
        } else {
          throw new Error("Response does not contain expected Data property.");
        }
      } catch (error) {
        console.error("Error fetching or processing data:", error);
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "black",
            font: {
              size: 14,
            },
          },
        },
      },
      animations: {
        animateRotate: true,
        animateScale: true,
      },
      interaction: {
        mode: "nearest",
        intersect: false,
        axis: "x",
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Stock Status Distribution
          </Typography>
        </Box>
        <Container>
          <div style={{ padding: "20px", width: "100%", height: "80%" }}>
            <Pie data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default OptimalStockChart;
